import React from "react";
import { Link } from "react-router-dom";
import { Copy, ArrowRight, Tag, ShoppingBag } from "lucide-react";
import { toast } from "sonner";

/**
 * TevaOutletReel — /share/teva-outlet
 * Time-boxed Teva UK OUTLET15 promotional reel.
 * Valid 22–28 Sep 2026 · 3am BST.
 */
const CAPTION = `☀️ Teva UK Outlet Sale — an EXTRA 15% off outlet, until 28 Sep.

Sandals, walking shoes, water shoes — every outlet piece an extra 15% off with code OUTLET15 at checkout.

The unsung hero of UK campsite ablution-block runs 🚿⛺

🏷 Use code OUTLET15
🗓 Ends 28 Sep 2026 · 3am BST

👉 Grab a pair via camp-compass.uk (link supports the app)
#TevaUK #CampCompass #UKCamping #OutletSale`;

export default function TevaOutletReel() {
  const copy = () => navigator.clipboard.writeText(CAPTION).then(() => toast.success("Caption copied"));
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  const affHref = `${backend}/api/affiliate/redirect?brand=teva-uk&dest=${encodeURIComponent("https://www.teva.com/en/outlet/")}&clickref=OUTLET15-reel`;
  return (
    <div className="min-h-screen bg-[#fffbf2]" data-testid="teva-outlet-reel">
      <div className="max-w-[420px] mx-auto p-4 space-y-3">
        <div className="text-center">
          <Link to="/launch-pack" className="text-[11px] mono uppercase tracking-widest text-[#ff4500] hover:underline">← Back to Launch Pack</Link>
          <h1 className="font-display text-2xl mt-1">Reel · Teva UK Outlet · OUTLET15</h1>
          <p className="text-xs text-[#666]">3 scenes · 9:16 · ends 28 Sep 2026</p>
        </div>
        <button onClick={copy} className="w-full inline-flex items-center justify-center gap-2 bg-[#0e0e0e] text-white text-xs font-black uppercase tracking-widest px-4 py-2.5" data-testid="teva-copy">
          <Copy className="w-3 h-3" /> Copy caption
        </button>
        <a href={affHref} target="_blank" rel="sponsored nofollow noopener" className="w-full inline-flex items-center justify-center gap-2 bg-[#ff4500] text-white text-xs font-black uppercase tracking-widest px-4 py-2.5" data-testid="teva-open">
          <ShoppingBag className="w-3 h-3" /> Open Teva UK outlet
        </a>

        <Scene bg="from-[#3a1500] via-[#6b2500] to-[#a04d00]" testid="teva-scene-1">
          <div className="text-white text-center flex-1 flex flex-col items-center justify-center p-6">
            <div className="inline-flex items-center gap-1.5 bg-white/20 px-3 py-1 text-[11px] mono uppercase tracking-widest font-black mb-4">
              <Tag className="w-3 h-3" /> Ends 28 Sep · 3am BST
            </div>
            <div className="font-display text-6xl leading-none mb-1">15%</div>
            <div className="font-display text-2xl leading-tight mb-3">extra off Teva outlet</div>
            <p className="text-white/85 text-sm">Sandals · walking shoes · water shoes</p>
          </div>
        </Scene>

        <Scene bg="from-[#f5d7a3] via-[#f2b45a] to-[#c47a1a]" testid="teva-scene-2">
          <div className="text-[#3a1500] text-center flex-1 flex flex-col items-center justify-center p-6">
            <p className="mono text-xs uppercase tracking-widest mb-3">Use code at checkout</p>
            <div className="bg-[#0e0e0e] text-white font-black tracking-[0.25em] text-3xl px-6 py-4 shadow-[0_6px_0_0_#3a1500]" data-testid="teva-code">
              OUTLET15
            </div>
            <p className="text-[#3a1500] text-sm mt-6">Extra 15% off every outlet product · limited time only.</p>
          </div>
        </Scene>

        <Scene bg="from-[#0e0e0e] via-[#1a1a1a] to-[#3a1500]" testid="teva-scene-3">
          <div className="text-white text-center flex-1 flex flex-col items-center justify-center p-6">
            <div className="font-display text-3xl leading-tight mb-3">Shop the outlet.</div>
            <p className="text-white/80 text-sm mb-6">Buy through CampCompass — supports our free tier.</p>
            <div className="bg-[#ff4500] text-white font-black uppercase tracking-widest text-xs px-5 py-3 inline-flex items-center gap-2">
              camp-compass.uk/teva <ArrowRight className="w-3.5 h-3.5" />
            </div>
          </div>
        </Scene>
      </div>
    </div>
  );
}

function Scene({ bg, testid, children }) {
  return (
    <div className={`aspect-[9/16] w-full flex flex-col bg-gradient-to-br ${bg}`} data-testid={testid}>
      {children}
    </div>
  );
}
